// extracted by mini-css-extract-plugin
export default {"image_container":"product-banner-creator_image_container__6mtas","fields_container":"product-banner-creator_fields_container__Hg2IV"};